var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHt = function SvgIconHt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 12 0 12 0s12 5.373 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M16.174 15.13 12 14.61l-4.174.521V8.87h8.348z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 14.608a2.087 2.087 0 1 0 0-4.174 2.087 2.087 0 0 0 0 4.174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M12 13.565a1.043 1.043 0 1 0 0-2.087 1.043 1.043 0 0 0 0 2.087"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M10.435 9.913h3.13L12 11.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12.522 10.956h-1.043v3.13h1.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M13.67 13.775h-3.34L7.826 15.13h8.348z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconHt;